import { deliveryMethodTypes } from "@@/shared/deliveries/delivery-methods";
import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";
import { orderStatusType } from "./order-status-types";

const orderStatusFulfilledZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal("FULFILLED"),
        deliveredBy: userIdZodSchema.optional(),
        deliveryType: z.enum(deliveryMethodTypes).optional(),
        verificationType: z.enum(["MANUAL", "QR", "AUTO"]),
        verificationCode: z.string(),
    }),
);
type OrderFulfilled = z.infer<typeof orderStatusFulfilledZodSchema>;

const orderStatusFulfilledFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly deliveredType?: OrderFulfilled["deliveryType"];
    readonly deliveredBy?: UserId;
    readonly verificationType: OrderFulfilled["verificationType"];
    readonly verificationCode: string; // MANUAL ? order-ref : order-ref+user-id
}): OrderFulfilled => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: orderStatusType.FULFILLED,
    deliveryType: params.deliveredType,
    deliveredBy: params.deliveredBy,
    verificationType: params.verificationType,
    verificationCode: params.verificationCode,
});

export { orderStatusFulfilledFactory, orderStatusFulfilledZodSchema };
export type { OrderFulfilled };
